import Vue from "vue";
import Component from "vue-class-component";
import {get} from "~/lib/helpers/objects";

const parseSortValue = (v, type) => {
  if (typeof type === "function") return type(v);
  if (type === "date") return (new Date(v)).valueOf();
  if (type === "string") return v.toLowerCase();
  if (type === "number") return +v;
  return v;
};

export type SortableCurrentSort = {
  key: string;
  order: "asc" | "desc";
  type: string;
};

@Component
export default class Sortable extends Vue {

  protected currentSort: SortableCurrentSort = { key: "", order: "asc", type: null };

  setCurrentSort(key, type = "string") {

    // Init sort
    if (!this.currentSort.key || (this.currentSort.key && this.currentSort.key !== key)) {
      this.currentSort = {key, order: "asc", type};
      return;
    }

    // toggle currentSort
    if (this.currentSort.key === key) {
      this.currentSort = {type, key, order: this.currentSort.order === "asc" ? "desc" : "asc"};
      return;
    }

  }

  sort(data) {

    let sorted = [...data];

    if (this.currentSort.key) {

      const {key, type, order} = this.currentSort;

      if (order === "asc") {
        sorted.sort((a, b) => {
          a = parseSortValue(get(a, key), type);
          b = parseSortValue(get(b, key), type);

          if (a === null) return 1;
          if (b === null) return -1;
          if (a > b) return -1;
          if (a < b) return 1;
          return 0;

        });
      } else if (order === "desc") {
        sorted.sort((a, b) => {

          a = parseSortValue(get(a, key), type);
          b = parseSortValue(get(b, key), type);

          if (a === null) return -1;
          if (b === null) return 1;
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
      }
    }

    return sorted;
  }

};
